import {Injectable} from '@angular/core';
import {BackendService} from 'auth/src/lib/services';
import {Observable} from 'rxjs';
import {AttributeItem, VisibilityRulesReview} from './interfaces/visibility-rules-review.interface';

@Injectable({
    providedIn: 'root'
})
export class ReviewsConfigService {

    constructor(private _backEndService: BackendService) {
    }

    public getAiReviewVisibilityConfigs(): Observable<{ data: VisibilityRulesReview[] }> {
        return this._backEndService.get('getVisibilityRules', [], []);
    }

    public getRuleByName(ruleName: string): Observable<{ data: VisibilityRulesReview }> {
        return this._backEndService.get('getVisibilityRules', [], [
            {name: 'ruleName', value: ruleName as any},
        ]);
    }

    public getAttributes(): Observable<{ data: { [key: number]: AttributeItem[] } }> {
        return this._backEndService.get('getReviewAttributes', [], []);
    }

    public addNewRule(originalRuleName: string, rule: VisibilityRulesReview): Observable<any> {
        return this._backEndService.post('addVisibilityRule',
            {
                originalRuleName: originalRuleName,
                visibilityRule: rule as any
            },
        );
    }

    public deleteVisibilityConfigs(name: string): Observable<{ data: VisibilityRulesReview[] }> {
        return this._backEndService.put('deleteVisibilityRuleGroup', {visibilityRuleName: name});
    }
}
